import { defineMessages } from 'react-intl'

export const values = {
  condition: {
    new_item: 'New',
    used_item: 'Used'
  },
  type: {
    aftermarket: 'Aftermarket',
    genuine: 'Genuine',
    remanufactured: 'Remanufactured'
  }
}

export default defineMessages({
  condition: {
    defaultMessage: 'Condition:'
  },
  warranty: {
    defaultMessage: 'Warranty:'
  },
  type: {
    defaultMessage: 'Type:'
  }
})
